<template>
  <div class="table table-responsive">
    <h4>Totalen</h4>
    <div class="table-responsive mb-4">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Waarde</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Gereserveerd</td>
            <td>{{gereserveerd}}</td>
          </tr>
          <tr>
            <td>Betaald</td>
            <td>{{betaald}}</td>
          </tr>
          <tr>
            <td>Openstaand</td>
            <td>{{openstaand}}</td>
          </tr>
          <tr>
            <td>Verstopt</td>
            <td>{{verstopt}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4>Reservaties</h4>
    <button class="btn btn-outline-primary" @click="resetAll()">Alles resetten :)</button>
    <table>
      <thead>
        <tr>
          <th v-for="col in cols" class="filterable" @click="setFilter(col)">{{col}}</th>
          <th>Tekstje</th>
          <th class="filterable" @click="setFilter('betaald')">Betaald</th>
          <th class="filterable" @click="setFilter('bedankt')">Bedankt</th>
        </tr>
      </thead>
      <template v-for="donatie in filtered(donaties)" >
        <tr :key="'row1_'+donatie.id">
          <td v-for="col in cols">{{donatie[col]}}</td>
          <td>
            <button class="btn btn-outline-primary" @click="$alertify.alert(donatie.tekstje)">i</button>
          </td>
          <td>
            <input
              type="checkbox"
              v-model="donatie.betaald"
              :true-value="true"
              :false-value="false"
              @change="setBetaald(donatie.id, donatie.betaald)"
              class="pl-3"
            >
          </td>
          <td>
            <input
              type="checkbox"
              class="pl-3"
              v-model="donatie.bedankt"
              :true-value="true"
              :false-value="false"
              @change="setBedankt(donatie.id, donatie.bedankt)"
            >
          </td>
        </tr>
        <tr :key="'row2_'+donatie.id">
          <td></td>
          <td></td>
          <td colspan="6">{{donatie.tekstje}}</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      donaties: [],
      filter: undefined,
      reverse: false
    };
  },
  computed: {
    ...mapState(["artikels"]),
    cols() {
      return ["voornaam", "achternaam", "email", "naam", "value"];
      return this.$_.uniq(
        this.$_.flatten(this.$_.map(this.donaties, x => this.$_.keys(x)))
      );
    },
    gereserveerd(){
      return this.$_.sum(this.$_.map(this.$_.filter(this.artikels, 'show'), 'prijs_donated'))
    },
    betaald(){
      return this.$_.sumBy(this.$_.filter(this.donaties, x=>x.betaald), x=>parseInt(x.value))
    },
    openstaand(){
      return this.$_.sum(this.$_.map(this.$_.filter(this.artikels, "show"), x=>x.prijs-x.prijs_donated))
    },
    verstopt(){ 
      return this.$_.sum(this.$_.map(this.$_.filter(this.artikels, x=>!x.show), "prijs"))
    }
  },
  async created() {
    this.get();
  },
  methods: {
    resetAll() {
      this.$alertify.confirm("alles resetten?", () => {
        Promise.all(
          this.$_.map(this.donaties, x => {
            return this.$firebase
              .firestore()
              .collection("donaties")
              .doc(x.id)
              .delete();
          })
        ).then(() => {
          this.$alertify.success("Alle donaties verwijderd");
        });
        Promise.all(
          this.$_.map(this.artikels, x => {
            let item = this.$_.clone(x);
            item.prijs_donated = 0;
            return this.$firebase
              .firestore()
              .collection("artikels")
              .doc(item.id)
              .set(item);
          })
        ).then(() => {
          this.$alertify.success("Alle artikels gereset!");
          this.$router.push("/");
        });
      });
    },
    async get() {
      let snapshot = await this.$firebase
        .firestore()
        .collection("donaties")
        .get();
      let donaties = [];
      snapshot.forEach(doc => {
        let item = doc.data();
        try {
          item.naam = this.$_.find(this.artikels, x => x.id == item.id).naam;
        } catch (err) {
          this.$alertify.error(`Geen artikel gevonden voor donatie ${doc.id}`);
          item.naam = "unknown"
        }
        item.id = doc.id;
        donaties.push(item);
      });
      this.$set(this, "donaties", donaties);
    },
    setFilter(col) {
      if (this.filter == col) {
        this.reverse = !this.reverse;
      } else {
        this.reverse = false;
      }
      this.filter = col;
    },
    setBetaald(id, value) {
      let docRef = this.$firebase
        .firestore()
        .collection("donaties")
        .doc(id);
      docRef.get().then(doc => {
        let item = this.$_.clone(doc.data());
        item.betaald = value;
        docRef
          .set(item)
          .then(res => this.$alertify.success("saved successfully!"));
      });
    },
    setBedankt(id, value) {
      let docRef = this.$firebase
        .firestore()
        .collection("donaties")
        .doc(id);
      docRef.get().then(doc => {
        let item = this.$_.clone(doc.data());
        item.bedankt = value;
        docRef
          .set(item)
          .then(res => this.$alertify.success("saved successfully!"));
      });
    },
    filtered(value) {
      let sort = this.$_.sortBy(value, this.filter);
      return this.reverse ? this.$_.reverse(sort) : sort;
    }
  }
};
</script>

<style>
.filterable {
  cursor: pointer;
}
</style>
